module.exports = __webpack_public_path__ + "img/banner_lhs_yf.aea29e2c.jpg";